import { Box, Typography, Grid2 as Grid, Card, CardContent, CardMedia, CardActionArea } from "@mui/material";
import Inspira1 from '../../../assets/images/2026/07/01_majestic-marian_thumbnail.png';
import Inspira2 from '../../../assets/images/2026/07/02_dia-internacional-de-la-amistad_thumbnail.png';
import Inspira3 from '../../../assets/images/2026/06/03_receta-dulce-de-verano_thumbnail.png';
import { useNavigate } from "react-router-dom";
import './inspiration.css';

const inspirationData = [
  {
    title: "Conoce Majestic Marián®, un surtido de galletas muy especial",
    text: "Descubre el postre perfecto para compartir en la sobremesa.",
    image: Inspira1,
    link: "/inspiracion/majestic-marian",
  },
  {
    title: "Rituales dulces para compartir en el Día Internacional de la Amistad",
    text: "Celebra el Día Internacional de la Amistad con actividades sencillas para compartir con amigas y crea rituales dulces con galletas Marián®.",
    image: Inspira2,
    link: "/inspiracion/dia-internacional-de-la-amistad",
  },
  {
    title: "Receta dulce de verano con Galletas Marián®",
    text: "Naked Cake con Bolitas de Nuez Marián®, la receta ideal para las reuniones de verano.",
    image: Inspira3,
    link: "/inspiracion/receta-dulce-de-verano",
  },
];

export default function Inspiration() {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: 6, px: 2, backgroundColor: "#fff", textAlign: "center" }} className="inspiration-container">
      <Typography
        className="inspiration-title"
        variant="h4"
        sx={{ color: "#E4535F", fontWeight: "bold", mb: 4, fontFamily: "BloodOrange, sans-serif" }}
      >
        ✧ Inspiración para crear ✧
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {inspirationData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <CardActionArea onClick={() => navigate(item?.link)} >
              <Card
                className="inspiration-card"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: index % 2 === 0 ? "column" : "column-reverse",
                  justifyContent: "space-between",
                  border: "none",
                  boxShadow: "none",
                  backgroundColor: "white"
                }}
              >
                <CardMedia
                  component="img"
                  height="300"
                  image={item.image}
                  alt={item.title}
                  sx={{ objectFit: "contain" }}
                />
                <CardContent sx={{ flexGrow: 1, maxWidth: 280, mx: "auto", textAlign: "left" }} className="inspiration-card-content">
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#E4535F", mb: 1, fontFamily: "BloodOrange, sans-serif" }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 6, // número de líneas visibles
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: "#3D1C02",
                      fontWeight: "500",
                      fontFamily: "Montserrat, sans-serif",
                    }}
                    component="div"
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                </CardContent>
              </Card>
            </CardActionArea>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
